import React from "react";
import { useParams } from "react-router-dom";
import { useObserver } from "mobx-react-lite";
import { Grid, Typography } from "@material-ui/core";
import { useAuthStore } from "stores/AuthStore";
import { Link, Dialog, Table } from "components";
import { StoreProvider, useStore } from "./Store";
import { FormStoreProvider, useFormStore } from "./FormStore";
import Form from "./Form";

interface Params {
  developerId: string;
}

export const Page = () => {
  const authStore = useAuthStore();
  const store = useStore();
  const formStore = useFormStore();
  const params = useParams<Params>();

  React.useEffect(() => {
    store.fetchAppGroups(+params.developerId);
  }, [params.developerId, store]);

  const open = React.useCallback(
    () =>
      formStore.modal(true, {
        regexpCampaign: "(?i)^layapp_.+",
        regexpPubTwitter: "",
      }),
    [formStore]
  );
  const close = React.useCallback(() => formStore.modal(false), [formStore]);

  const data = store.appGroups.map((appGroup) => ({
    ...appGroup,
    trackingVendor: appGroup.apps[0]?.trackingVendor,
    ios: appGroup.apps.find((a) => a.os === "ios"),
    android: appGroup.apps.find((a) => a.os === "android"),
  }));

  return useObserver(() => (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs="auto">
        <Typography variant="h6" color="textSecondary">
          アプリ
        </Typography>
      </Grid>

      {authStore.admin() && (
        <Grid item xs="auto">
          <Dialog
            title="アプリ"
            open={formStore.dialog}
            onOpen={open}
            onClose={close}
          >
            <Form developerId={+params.developerId} />
          </Dialog>
        </Grid>
      )}

      <Grid item xs={12}>
        <Table
          title=""
          isLoading={store.loading}
          options={{
            exportFileName: "アプリ",
          }}
          data={data}
          columns={[
            { title: "名前", field: "name" },
            { title: "計測ベンダー", field: "trackingVendor.name" },
            {
              title: "iOS App ID",
              field: "ios.appId",
              render: (appGroup) =>
                appGroup.ios && (
                  <Link
                    to={`/developers/${params.developerId}/apps/${appGroup.ios.id}`}
                  >
                    {appGroup.ios.appId}
                  </Link>
                ),
            },
            {
              title: "Android App ID",
              field: "android.appId",
              render: (appGroup) =>
                appGroup.android && (
                  <Link
                    to={`/developers/${params.developerId}/apps/${appGroup.android.id}`}
                  >
                    {appGroup.android.appId}
                  </Link>
                ),
            },
            { title: "Red 広告主 ID", field: "redUserId" },
            { title: "Twitter アカウント ID", field: "twitterUserId" },
          ]}
          actions={[
            {
              hidden: !authStore.admin(),
              icon: "edit",
              tooltip: "編集",
              onClick: (_, appGroup) =>
                !Array.isArray(appGroup) &&
                formStore.modal(true, {
                  id: appGroup.id,
                  name: appGroup.name,
                  trackingVendorId: appGroup.trackingVendor?.id,
                  iosAppId: appGroup.ios?.appId,
                  androidAppId: appGroup.android?.appId,
                  regexpCampaign: appGroup.apps[0]?.regexpCampaign,
                  regexpPubTwitter: appGroup.apps[0]?.regexpPubTwitter,
                }),
            },
          ]}
        />
      </Grid>
    </Grid>
  ));
};

export default () => (
  <StoreProvider>
    <FormStoreProvider>
      <Page />
    </FormStoreProvider>
  </StoreProvider>
);
